import { render, staticRenderFns } from "./Quiz.vue?vue&type=template&id=f1af215c"
import script from "./Quiz.vue?vue&type=script&lang=js"
export * from "./Quiz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/maq/Code/skyier/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f1af215c')) {
      api.createRecord('f1af215c', component.options)
    } else {
      api.reload('f1af215c', component.options)
    }
    module.hot.accept("./Quiz.vue?vue&type=template&id=f1af215c", function () {
      api.rerender('f1af215c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/player/components/Quiz.vue"
export default component.exports